<template lang="pug">
  tbody
    tr
      td(style="font-weight: 500;") Box - {{ box.id }}
      td {{ quantity }}
      td {{ box.weight }}
      td {{ box.length }}
      td {{ box.width }}
      td {{ box.height }}
      td {{ box.created_at }}
    tr
      td.table-collapse-inner(colspan="9")
        div.table-collapse-body
          table
            thead
              tr.products-preview
                th.td-05 Image
                th.td-15 Title
                th.td-1 Asin
                th.td-1 Fnsku
                th.td-05 Condition
                th.td-05 Quantity
                th.td-05(v-if="app_section === 'storage'") Size
                th.td-15 Received date
                th.td-15 Client comment
                th.td-15 Worker comment
            product_component(v-for="product in box.products",
              :key="product.id", :product="product")
</template>

<script>
import productComponent from './product/product.vue';

export default {
  props: [
    'box',
    'index',
  ],
  components: {
    product_component: productComponent,
  },
  computed: {
    quantity() {
      if (typeof this.box === 'undefined') return false;

      return this.box.products.reduce((accumulator, currentValue) => (
        accumulator + currentValue.quantity
      ), 0);
    },
    app_section() {
      return this.$store.getters.get_app_section;
    },
  },
};
</script>
